import React, { FC } from 'react';
import { TextInput } from 'react-admin';

interface JsonInputProps {
  label: string;
  source: string;
  className?: string;
  validationError: string;
  initialValue?: string;
  defaultValue?: string;
  validationEmptyError?: string;
  required?: boolean;
}

export const JsonInput: FC<JsonInputProps> = ({
  label,
  source,
  className,
  validationError,
  initialValue,
  defaultValue = '{}',
  validationEmptyError,
  required,
}) => {
  return (
    <TextInput
      required={required}
      multiline
      label={label}
      source={source}
      className={className}
      initialValue={initialValue || '{}'}
      validate={(v: any) => {
        if (v) {
          try {
            // If it's already an object, it's valid
            if (typeof v === 'object') {
              return '';
            }
            // If it's a string, try to parse it
            if (typeof v === 'string') {
              JSON.parse(v);
              const parsed = JSON.parse(v);
              if (
                validationEmptyError &&
                Array.isArray(parsed) &&
                (parsed.length === 0 || parsed.length === 1) &&
                typeof parsed[0] === 'object' &&
                Object.keys(parsed[0]).length === 0
              ) {
                return validationEmptyError;
              }
            }
            return '';
          } catch (e) {
            return validationError;
          }
        }
        if (required) {
          return validationError;
        }
      }}
      format={(v: any) => {
        if (typeof v === 'object') {
          return JSON.stringify(v, null, 2);
        } else if (!v) {
          return defaultValue;
        }
        return v;
      }}
    />
  );
};
